import Vue from 'vue';

Vue.filter('filesize', (value) => {
    const i = Math.floor(Math.log(value) / Math.log(1024) );
    return `${(value / (1024 ** i)).toFixed(2) * 1} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
});
